import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { SmsNotificationSettings } from "./sms-notification-settings.model";

export const ACTION_PREFIX = "[SMS Notification Settings]";

export const SMS_NOTIFICATION_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export class SmsNotificationSettingsAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	getAll(): Action {
		return createCachedGetAction({
			type: SMS_NOTIFICATION_ACTION_TYPE.getAll,
		});
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	getAllSuccess(settings: SmsNotificationSettings): ActionWithPayload {
		return {
			type: SMS_NOTIFICATION_ACTION_TYPE.getAllSuccess,
			payload: settings,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: SMS_NOTIFICATION_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateSmsNotificationSettings) instead
	 */
	update(settings: SmsNotificationSettings): ActionWithPayload {
		return {
			type: SMS_NOTIFICATION_ACTION_TYPE.update,
			payload: settings,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateSmsNotificationSettings) instead
	 */
	updateSuccess(settings: SmsNotificationSettings): ActionWithPayload {
		return {
			type: SMS_NOTIFICATION_ACTION_TYPE.updateSuccess,
			payload: settings,
		};
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateSmsNotificationSettings) instead
	 */
	updateFail(error: AppError): ActionWithPayload {
		return {
			type: SMS_NOTIFICATION_ACTION_TYPE.updateFail,
			payload: error,
		};
	}
}
